import { useCallback, useMemo } from 'react';
import { viewCheckbookCategories } from 'src/assets/static/view_checkbook/useCheckbookCategories';
import ClearFilterButton from 'src/components/design-system/ClearFilterButton';
import useViewCheckbook from 'src/hooks/useViewCheckbook';
import useYearView from 'src/hooks/useYearView';
import { initialYearCheckbookDataState } from '../ViewCheckbookContext';

const ClearFilters = () => {
  const {
    setYearCheckbookDataState,
    yearCheckbookDataState,
    confirmBeforeProceeding,
    setEditingGlCodeYearBudget,
    isEditMode,
    setGlCodesBudgetByYear,
  } = useViewCheckbook();
  const { setYearViewDropdownFilter, yearViewDropdownFilter } = useYearView();

  const handleClearFilter = useCallback(() => {
    confirmBeforeProceeding(() => {
      setYearViewDropdownFilter(viewCheckbookCategories?.[2]);
      setYearCheckbookDataState({ ...initialYearCheckbookDataState });
    });
    if (isEditMode) {
      setEditingGlCodeYearBudget((prev) => prev?.map((row) => ({ ...row, selected: false })));
    } else {
      setGlCodesBudgetByYear((prev) => prev?.map((row) => ({ ...row, selected: false })));
    }
  }, [
    confirmBeforeProceeding,
    isEditMode,
    setEditingGlCodeYearBudget,
    setGlCodesBudgetByYear,
    setYearCheckbookDataState,
    setYearViewDropdownFilter,
  ]);

  const isClearFiltersDisabled = useMemo(
    () =>
      yearViewDropdownFilter?.value === 2 ? !yearCheckbookDataState.filter?.filters.length : false,
    [yearCheckbookDataState.filter?.filters.length, yearViewDropdownFilter?.value]
  );

  return <ClearFilterButton disabled={isClearFiltersDisabled} onClick={handleClearFilter} />;
};

export default ClearFilters;
